import React from 'react';
import { useNavigate } from 'react-router-dom';
import { animated, useSpring } from '@react-spring/web';
import './SplashPage.css';

const SplashPage = () => {
  const navigate = useNavigate();

  // Animation for SVG
  const svgAnimation = useSpring({
    from: { transform: 'scale(0.8)', opacity: 0 },
    to: { transform: 'scale(1)', opacity: 1 },
    config: { duration: 1000 },
  });

  return (
    <div className="splash-container">
      <animated.div style={svgAnimation} className="splash-illustration">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          width="200"
          height="200"
          className="splash-svg"
        >
          <circle cx="32" cy="32" r="30" fill="#42224A" />
          <rect x="20" y="25" width="24" height="14" rx="2" ry="2" fill="#EF8767" />
          <path
            d="M26 39h12v4H26z"
            fill="#f5f5f5"
          />
          <circle cx="32" cy="25" r="3" fill="#fff" />
        </svg>
      </animated.div>
      <h1 className="splash-title">Manage Your Expenses</h1>
      <p className="splash-description">
        Simplify your finances with ease.
      </p>
      <div className="splash-buttons">
        <button
          className="splash-button signin-button"
          onClick={() => navigate('/login')}
        >
          Sign In
        </button>
        <button
          className="splash-button signup-button"
          onClick={() => navigate('/register')}
        >
          Sign Up
        </button>
      </div>
    </div>
  );
};

export default SplashPage;
